export const candidateProfileGroups = [
  {
    "key": "identity",
    "label": "Személyes adatok",
    "fields": [
      {
        "name": "first_name",
        "label": "Vezetéknév",
        "type": "text",
        "required": true
      },
      {
        "name": "last_name",
        "label": "Keresztnév",
        "type": "text",
        "required": true
      },
      {
        "name": "birth_name",
        "label": "Születési név",
        "type": "text"
      },
      {
        "name": "mother_name",
        "label": "Anyja neve",
        "type": "text"
      },
      {
        "name": "birthday",
        "label": "Születési dátum",
        "type": "date"
      },
      {
        "name": "birth_place",
        "label": "Születési hely",
        "type": "text"
      },
      {
        "name": "gender",
        "label": "Nem",
        "type": "text"
      },
      {
        "name": "citizenship",
        "label": "Állampolgárság",
        "type": "relation",
        "options": "citizenship",
        "path": "citizenship.id"
      }
    ]
  },
  {
    "key": "contact",
    "label": "Elérhetőségek",
    "fields": [
      {
        "name": "email",
        "label": "E-mail-cím",
        "type": "email"
      },
      {
        "name": "phone",
        "label": "Telefonszám",
        "type": "text"
      },
      {
        "name": "phone_country_code",
        "label": "Telefon országkód",
        "type": "text"
      },
      {
        "name": "phone_area_code",
        "label": "Telefon körzetszám",
        "type": "text"
      },
      {
        "name": "phone_number",
        "label": "Helyi telefonszám",
        "type": "text"
      },
      {
        "name": "phone_suffix",
        "label": "Mellék",
        "type": "text"
      }
    ]
  },
  {
    "key": "address",
    "label": "Cím",
    "fields": [
      {
      "name": "country",
      "label": "Ország",
      "type": "country",
        "maxLength": 2
      },
      {
        "name": "city",
        "label": "Város",
        "type": "city",
        "path": "city.name"
      },
      {
        "name": "zip",
        "label": "Irányítószám",
        "type": "text"
      },
      {
        "name": "address",
        "label": "Utca, házszám, egyéb címadat",
        "type": "text"
      }
    ]
  },
  {
    "key": "identifiers",
    "label": "Azonosítók",
    "fields": [
      {
        "name": "tax_number",
        "label": "Adóazonosító jel",
        "type": "text"
      },
      {
        "name": "insurance_number",
        "label": "TAJ-szám",
        "type": "text"
      },
      {
        "name": "id_card",
        "label": "Személyi igazolvány száma",
        "type": "text"
      },
      {
        "name": "bank_account",
        "label": "Bankszámlaszám",
        "type": "text"
      }
    ]
  },
  {
    "key": "work",
    "label": "Munkavállalási adatok",
    "fields": [
      {
        "name": "employment_status",
        "label": "Foglalkoztatási státusz",
        "type": "text"
      },
      {
        "name": "position",
        "label": "Munkakör",
        "type": "text"
      },
      {
        "name": "recruitment_work_types",
        "label": "Munkatípusok",
        "type": "many",
        "options": "recruitment_work_types",
        "path": "recruitment_work_types.id"
      },
      {
        "name": "recruitment_regions",
        "label": "Munkavégzési régiók",
        "type": "many",
        "options": "recruitment_regions",
        "path": "recruitment_regions.id"
      },
      {
        "name": "trainee",
        "label": "Gyakornok",
        "type": "boolean"
      },
      {
        "name": "untrained",
        "label": "Szakképzettség nélkül",
        "type": "boolean"
      },
      {
        "name": "part_time",
        "label": "Részmunkaidő",
        "type": "boolean"
      }
    ]
  },
  {
    "key": "student",
    "label": "Tanulói adatok",
    "fields": [
      {
        "name": "student",
        "label": "Tanuló",
        "type": "boolean"
      },
      {
        "name": "student_card_number",
        "label": "Diákigazolvány száma",
        "type": "text"
      },
      {
        "name": "student_card_valid",
        "label": "Diákigazolvány érvényessége",
        "type": "date"
      },
      {
        "name": "student_card_check",
        "label": "Diákigazolvány ellenőrzése",
        "type": "date"
      },
      {
        "name": "educational_institution",
        "label": "Oktatási intézmény",
        "type": "text"
      },
      {
        "name": "educational_city",
        "label": "Intézmény települése",
        "type": "text"
      },
      {
        "name": "educational_zip",
        "label": "Intézmény irányítószáma",
        "type": "text"
      },
      {
        "name": "educational_address",
        "label": "Intézmény címe",
        "type": "text"
      }
    ]
  },
  {
    "key": "driving",
    "label": "Vezetői engedélyek",
    "fields": [
      {
        "name": "driver_license_a",
        "label": "A kategória",
        "type": "boolean"
      },
      {
        "name": "driver_license_b",
        "label": "B kategória",
        "type": "boolean"
      },
      {
        "name": "driver_license_c",
        "label": "C kategória",
        "type": "boolean"
      },
      {
        "name": "driver_license_d",
        "label": "D kategória",
        "type": "boolean"
      },
      {
        "name": "driver_license_e",
        "label": "E kategória",
        "type": "boolean"
      },
      {
        "name": "driver_license_forklift",
        "label": "Targonca",
        "type": "boolean"
      },
      {
        "name": "driver_license_logistics",
        "label": "Logisztika",
        "type": "boolean"
      },
      {
        "name": "driver_license_agrarian",
        "label": "Agrár",
        "type": "boolean"
      },
      {
        "name": "driver_license_none",
        "label": "Nincs vezetői engedély",
        "type": "boolean"
      },
      {
        "name": "have_car",
        "label": "Saját gépjármű",
        "type": "boolean"
      }
    ]
  },
  {
    "key": "computer",
    "label": "Számítógépes ismeretek",
    "fields": [
      {
        "name": "computer_knowledge_word",
        "label": "Word",
        "type": "boolean"
      },
      {
        "name": "computer_knowledge_excel",
        "label": "Excel",
        "type": "boolean"
      },
      {
        "name": "computer_knowledge_outlook",
        "label": "Outlook",
        "type": "boolean"
      },
      {
        "name": "computer_knowledge_powerpoint",
        "label": "Powerpoint",
        "type": "boolean"
      },
      {
        "name": "computer_knowledge_access",
        "label": "Access",
        "type": "boolean"
      },
      {
        "name": "computer_knowledge_sap",
        "label": "Sap",
        "type": "boolean"
      },
      {
        "name": "computer_knowledge_autocad",
        "label": "Autocad",
        "type": "boolean"
      },
      {
        "name": "computer_knowledge_photoshop",
        "label": "Photoshop",
        "type": "boolean"
      },
      {
        "name": "computer_knowledge_internet",
        "label": "Internet",
        "type": "boolean"
      },
      {
        "name": "computer_knowledge_none",
        "label": "Nincs számítógépes ismeret",
        "type": "boolean"
      },
      {
        "name": "computer_knowledge_other",
        "label": "Egyéb ismeretek",
        "type": "text"
      }
    ]
  },
  {
    "key": "administration",
    "label": "Nyilvántartási adatok",
    "fields": [
      {
        "name": "active",
        "label": "Aktív",
        "type": "boolean",
        "required": true
      },
      {
        "name": "approved",
        "label": "Ellenőrzött",
        "type": "boolean",
        "required": true
      },
      {
        "name": "general_registration",
        "label": "Általános regisztráció",
        "type": "boolean",
        "required": true
      },
      {
        "name": "newsletter",
        "label": "Hírlevél",
        "type": "boolean"
      },
      {
        "name": "source",
        "label": "Forrás",
        "type": "text"
      },
      {
        "name": "recruitment_ad_sources",
        "label": "Hirdetési források",
        "type": "many",
        "options": "recruitment_ad_sources",
        "path": "recruitment_ad_sources.id"
      },
      {
        "name": "note",
        "label": "Megjegyzés",
        "type": "textarea"
      }
    ]
  }
];
export const candidateSearchGroups = [...candidateProfileGroups, {
  "key": "related",
  "label": "Kapcsolódó adatok",
  "fields": [
    {
      "name": "education_level",
      "label": "Végzettségi szint",
      "type": "relation",
      "options": "education_level",
      "path": "educations.education_level.id"
    },
    {
      "name": "education_master",
      "label": "Végzettség megnevezése",
      "type": "text",
      "path": "educations.master"
    },
    {
      "name": "education_school",
      "label": "Végzettség intézménye",
      "type": "text",
      "path": "educations.school"
    },
    {
      "name": "language",
      "label": "Nyelvismeret",
      "type": "relation",
      "options": "language",
      "path": "languages.language.id"
    },
    {
      "name": "language_level",
      "label": "Nyelvtudás szintje",
      "type": "text",
      "path": "languages.level"
    },
    {
      "name": "experience_company",
      "label": "Korábbi munkáltató",
      "type": "text",
      "path": "work_experiences.company_name"
    },
    {
      "name": "experience_job",
      "label": "Korábbi munkakör",
      "type": "text",
      "path": "work_experiences.job"
    },
    {
      "name": "is_employee",
      "label": "Munkavállaló",
      "type": "boolean"
    }
  ]
}];

export function candidateSearchQuery(values) {
  const query = new URLSearchParams();
  candidateSearchGroups.flatMap(g => g.fields).forEach(f => {
    const value = values[f.name];
    if (value === null || value === undefined || value === '' || (Array.isArray(value) && !value.length)) return;
    const key = 'search[' + (f.path || f.name) + ']';
    const like = ['text', 'textarea', 'email', 'city'].includes(f.type);
    query.set(key + '[operator]', f.type === 'many' ? 'in' : like ? 'like' : '=');
    if (Array.isArray(value)) value.forEach(id => query.append(key + '[value][]', id));
    else query.set(key + '[value]', like ? '*' + String(value).trim() + '*' : typeof value === 'boolean' ? (value ? '1' : '0') : value);
  });
  return query.toString();
}
export function candidatePayload(values, changedFields = null) {
  const payload = {};
  candidateProfileGroups.flatMap(g => g.fields).forEach(f => {
    if ((changedFields && !changedFields.includes(f.name)) || values[f.name] === undefined) return;
    const value = values[f.name];
    payload[f.name] = f.type === 'city' || f.type === 'relation' ? value?.id ?? value ?? null
      : f.type === 'many' ? (value || []).map(item => item?.id ?? item)
      : f.type === 'date' ? (value ? value.slice(0, 10) : null) : value === '' ? null : value;
  });
  return payload;
}
